export default "__VITE_ASSET__C6yjEbU0__"